import farmacieRaw from '../../public/data/farmacie.json'
import { AMBITI_STATS, type AmbitoId } from './ambitiStats'

const BASE_FIELDS = new Set(['COD. FARMACIA', 'RAGIONE SOCIALE', 'INDIRIZZO', '', 'FRAZIONE', 'COMUNE', 'PROVINCIA', 'COMUNALE'])

function normalizeComune(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[''`\u2018\u2019]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

const COMUNE_TO_AMBITO = new Map<string, AmbitoId>()
for (const ambito of AMBITI_STATS) {
  for (const comune of ambito.comuni) {
    COMUNE_TO_AMBITO.set(normalizeComune(comune), ambito.id)
  }
}

export interface Farmacia {
  id: string
  codice: string
  ragioneSociale: string
  indirizzo: string
  telefono: string
  frazione: string
  comune: string
  provincia: string
  comunale: boolean
  ambitoId: AmbitoId | null
  servizi: Record<string, string>
}

type RawFarmacia = Record<string, string>

export const FARMACIE: Farmacia[] = (farmacieRaw.farmacie as RawFarmacia[]).map((f, i) => {
  const ambitoId = COMUNE_TO_AMBITO.get(normalizeComune(f['COMUNE'] ?? '')) ?? null
  const servizi: Record<string, string> = {}
  for (const [k, v] of Object.entries(f)) {
    if (!BASE_FIELDS.has(k)) servizi[k] = v ?? ''
  }
  return {
    id: `farmacia-${i}-${(f['COD. FARMACIA'] ?? '').toLowerCase().replace(/[^a-z0-9]/g, '-')}`,
    codice: f['COD. FARMACIA'] ?? '',
    ragioneSociale: f['RAGIONE SOCIALE'] ?? '',
    indirizzo: f['INDIRIZZO'] ?? '',
    telefono: f[''] ?? '',
    frazione: f['FRAZIONE'] ?? '',
    comune: f['COMUNE'] ?? '',
    provincia: f['PROVINCIA'] ?? '',
    comunale: f['COMUNALE'] === 'SI',
    ambitoId,
    servizi,
  }
})

export const FARMACIE_SERVICE_KEYS: string[] = (() => {
  const counts = new Map<string, number>()
  for (const f of FARMACIE) {
    for (const [k, v] of Object.entries(f.servizi)) {
      if (v && v.trim() !== '') {
        counts.set(k, (counts.get(k) ?? 0) + 1)
      }
    }
  }
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'it'))
    .map(([k]) => k)
})()

export function farmaciaSlug(f: Farmacia): string {
  return `${f.codice}-${f.ragioneSociale}`
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function findFarmaciaBySlug(slug: string): Farmacia | undefined {
  return FARMACIE.find(f => farmaciaSlug(f) === slug)
}

export const FARMACIE_FONTE = farmacieRaw.fonte
export const FARMACIE_LINK = farmacieRaw.link
export const FARMACIE_ULTIMO_AGGIORNAMENTO = farmacieRaw.ultimoAggiornamento
